import React from "react";
import { Box } from "@mui/material";
import { getDealLabel } from "../helpers/dealHelpers";

export default function DealBadge({ product }) {
  const label = getDealLabel(product);

  if (!label) {
    return null;
  }

  return (
    <Box
      component="span"
      aria-label={`מבצע: ${label}`}
      sx={{
        position: "absolute",

        top: {
          xs: 6,
          sm: 8,
          md: 10,
        },

        left: {
          xs: 6,
          sm: 8,
          md: 10,
        },

        maxWidth: {
          xs: "calc(100% - 12px)",
          sm: "calc(100% - 16px)",
          md: "calc(100% - 20px)",
        },

        backgroundColor: "#D81B60",
        color: "#ffffff",

        px: {
          xs: 0.8,
          sm: 1.2,
          md: 1.7,
        },

        py: {
          xs: 0.35,
          sm: 0.5,
          md: 0.7,
        },

        borderRadius: "999px",

        fontSize: {
          xs: "0.62rem",
          sm: "0.75rem",
          md: "0.875rem",
        },

        lineHeight: 1.25,
        fontWeight: 700,
        zIndex: 5,

        minWidth: {
          xs: 0,
          sm: 45,
          md: 55,
        },

        textAlign: "center",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        boxSizing: "border-box",
        boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
        pointerEvents: "none",
      }}
    >
      {label}
    </Box>
  );
}